import { useState } from 'react'
import { signInWithGoogle } from '../lib/supabase'

export function LoginPage() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleLogin() {
    setLoading(true)
    setError(null)
    try {
      await signInWithGoogle()
    } catch (e) {
      setError('ログインに失敗しました。再度お試しください。')
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0e0f12',
      fontFamily: '"Inter", -apple-system, system-ui, sans-serif',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 32,
        padding: '48px 40px',
        background: '#15171c',
        border: '1px solid #23262d',
        borderRadius: 12,
        width: 360,
      }}>
        {/* ロゴ */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12,
            background: 'linear-gradient(135deg, oklch(0.72 0.15 260) 0%, oklch(0.62 0.18 280) 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 700, fontSize: 22,
            fontFamily: 'ui-monospace, monospace',
          }}>M</div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 20, fontWeight: 600, color: '#e7e9ee' }}>MemoLake</div>
            <div style={{ fontSize: 12, color: '#5b616d', fontFamily: 'ui-monospace, monospace', marginTop: 4 }}>
              Discord × Gemini パーソナルデータレイク
            </div>
          </div>
        </div>

        {/* ログインボタン */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}>
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              padding: '12px 20px',
              background: loading ? '#212530' : '#fff',
              color: loading ? '#5b616d' : '#1a1a1a',
              border: '1px solid #23262d',
              borderRadius: 8,
              fontSize: 14, fontWeight: 500,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit',
              transition: 'background 0.15s',
            }}
          >
            {/* Google ロゴ SVG */}
            {!loading && (
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
                <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
                <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.31z"/>
              </svg>
            )}
            {loading ? 'ログイン中...' : 'Google アカウントでログイン'}
          </button>

          {error && (
            <div style={{
              padding: '10px 14px',
              background: 'oklch(0.78 0.14 70 / 0.12)',
              border: '1px solid oklch(0.78 0.14 70 / 0.3)',
              borderRadius: 6,
              fontSize: 12, color: 'oklch(0.86 0.12 70)',
              textAlign: 'center',
            }}>
              {error}
            </div>
          )}
        </div>

        <div style={{ fontSize: 11, color: '#5b616d', textAlign: 'center', lineHeight: 1.6 }}>
          許可されたアカウントのみログインできます
        </div>
      </div>
    </div>
  )
}
